import {
    RECEIVED_CART_DATA,
    RECEIVED_COMPARE_DATA,
    RECEIVED_LIST_DATA,
    RECEIVED_LIST_FILTERS_TRIGGERED,
    RECEIVED_LIST_LIMIT_PAGE,
    RECEIVED_LIST_PAGINATOR_TRIGGERED,
    RECEIVED_LIST_WITH_SEARCH,
    RECEIVED_SEARCH_DATA,
    RECEIVED_SORTING_LIST_DATA,
    RECEIVED_WISH_DATA,
    PRODUCTS_WISH_ADDED_DATA,
    PRODUCTS_CART_ADDED_DATA,
    CLEAR_ALL_STATES,
    PRODUCTS_COMPARE_ADDED_DATA,
    REMOVED_WISH_DATA,
    REMOVED_COMPARE_DATA,
    SHOW_LOADER_ACTION,
    CLEAR_FILTERS,
    CLEAR_SEARCH_DATA, RECEIVED_SEARCH_DATA_ART
} from "../actions/list";
import {RECEIVED_FILTERS, ADD_NEW_FILTER_VALUE, REMOVE_FILTER_VALUE, CHANGE_RANGE_FILTER} from "../actions/filters";


const initialState = {
    listGoods: {},
    isShowLoader: true,
    dataFilters: {},
    showLoader: true,
    currentCategory: null,
    filtersSelected: [],
    conditionSelected: [],
    minMaxSelected: [],
    filterIdTriggered: null,
    sortingData: [],
    urlForChange: null,
    pageNum: 1,
    search: '',
    searchArt:'',
    limit: '20',
    countCart: 0,
    countWish: 0,
    isChangeUrl: false,
    isDiscount: false,
    filtersByGoods: {},
    filtersByGoodsForCount: {}
};

export default function getsListProducts(state = initialState, action){
    switch ( action.type ) {
        case CLEAR_SEARCH_DATA:
            return {...state, search: null}
            break;
        case RECEIVED_LIST_DATA:
            console.log("actio 41", action );
                var data = {
                    ...state,
                    listGoods: action.listGoods,
                    filtersByGoods: action.listGoods.filtersByGoods,
                    filtersByGoodsForCount: action.listGoods.filtersByGoodsForCount,
                    isShowLoader: false,
                    currentCategory: action.category,
                    filtersSelected: action.filters['filtersSelected']!== undefined?action.filters['filtersSelected']:[],
                    conditionSelected: action.filters['conditionSelected']!==undefined?action.filters['conditionSelected']:[],
                    minMaxSelected: action.filters['storeMinMax']!==undefined?action.filters['storeMinMax']:[],
                    sortingData: action.filters['sorting']!==undefined?action.filters['sorting']:initialState.sortingData,
                    pageNum: action.filters["pageNum"]!==undefined?action.filters["pageNum"]:initialState.pageNum,
                    limit: action.filters["limit"]!==undefined?action.filters["limit"]:action.listGoods.numItemsPerPage,
                    isDiscount: action.filters['is_discount']!==undefined?action.filters['is_discount']:null,
                    urlForChange: "",
                    isChangeUrl: false,
                    search: action.filters["search"]!==undefined?action.filters["search"]:null,
                    searchArt: action.filters["searchArt"]!==undefined?action.filters["searchArt"]:null
                };
            return data;
            break;

        case RECEIVED_LIST_FILTERS_TRIGGERED:
            return {
                ...state,
                listGoods: action.listGoods,
                filtersByGoods: action.listGoods.filtersByGoods,
                filtersByGoodsForCount: action.listGoods.filtersByGoodsForCount,
                urlForChange: action.url,
                isChangeUrl: true,
                isShowLoader: false
            }
            break;

        case RECEIVED_FILTERS:
            return {
                ...state,
                dataFilters: action.dataFilters,
                showLoader: false,
            }
            break;

        case ADD_NEW_FILTER_VALUE:
            return {
                ...state,
                filtersSelected: state.filtersSelected.concat(action.filter),
                conditionSelected: state.conditionSelected.concat(action.conditionFilter)
            }
            break;
        case REMOVE_FILTER_VALUE:
            return {
                ...state,
                filtersSelected: state.filtersSelected.filter(item => item !== action.filter),
                conditionSelected: state.conditionSelected.filter(item => item !==action.conditionFilter)
            }
            break;
        case CHANGE_RANGE_FILTER:
            var newData = [];
            newData[action.filterId] = [];
            newData[action.filterId]['min'] = action.filterMin;
            newData[action.filterId]['max'] = action.filterMax;
            return{
                ...state,
                 minMaxSelected: Object.assign({}, state.minMaxSelected, newData ),
                filterIdTriggered: action.filterId
            }
            break;

        case RECEIVED_SORTING_LIST_DATA:
            return {
                ...state,
                listGoods: action.listGoods,
                sortingData: action.orderingData,
                isChangeUrl: true,
                urlForChange: action.urlForChange,
                isShowLoader: false
            }
            break;

        case RECEIVED_LIST_PAGINATOR_TRIGGERED:
            return {
                ...state,
                listGoods: action.listGoods,
                pageNum: action.objectPageLimit.page,
                limit: action.objectPageLimit.limit,
                urlForChange: action.urlForChange,
                isChangeUrl: true,
                isShowLoader: false
            }
            break;

        case RECEIVED_LIST_LIMIT_PAGE:
            return {
                ...state,
                listGoods: action.listGoods,
                limit: action.limit,
                urlForChange: action.urlForChange,
                isChangeUrl: true,
                pageNum: action.pageNum,
                isShowLoader: false
            }
            break;

        case RECEIVED_LIST_WITH_SEARCH:
            return {
                ...state,
                listGoods: action.listGoods,
                urlForChange: action.urlForChange,
                isChangeUrl: true,
                pageNum: action.pageNum,
                isShowLoader: false
            }
            break;

        case RECEIVED_SEARCH_DATA:
            return {
                ...state,
                search: action.search,
                isShowLoader: false
            }
            break;

        case RECEIVED_SEARCH_DATA_ART:
            return {
                ...state,
                searchArt: action.searchArt,
                isShowLoader: false
            }
            break;
        case  RECEIVED_CART_DATA:
            return {
                ...state,
                countCart: action.countCart
            }
            break;

        case RECEIVED_WISH_DATA:
            return {
                ...state,
                countWish: action.countWish
            }
            break;

        case RECEIVED_COMPARE_DATA:
            return {
                ...state,
                countCompare: action.countCompare
            }
            break;

        //**********************************
        case  PRODUCTS_CART_ADDED_DATA:
            return {
                ...state,
                countCart: state.countCart+1,
                isShowLoader: false
            }
            break;

        case SHOW_LOADER_ACTION:
            return {
                ...state,
                isShowLoader: true
            }
            break;

        case PRODUCTS_WISH_ADDED_DATA:
            return {
                ...state,
                countWish: state.countWish +1,
                listGoods: Object.assign( {} ,state.listGoods, {wishList: state.listGoods.wishList.concat(parseInt(action.id)) }),
                isShowLoader: false
            }
            break;

        case REMOVED_WISH_DATA:
            return {
                ...state,
                countWish:  state.countWish -1,
                listGoods: Object.assign( {} ,state.listGoods, {wishList: state.listGoods.wishList.filter( elem => elem !== parseInt(action.id)) }),
                isShowLoader: false
            }
            break;
        case PRODUCTS_COMPARE_ADDED_DATA:
            return {
                ...state,
                countCompare: state.countCompare+1,
                listGoods: Object.assign({}, state.listGoods, {compareList: state.listGoods.compareList.concat(parseInt(action.id))} ),
                isShowLoader: false
            }
            break;
        //********************************************

        case REMOVED_COMPARE_DATA:
            return {
                ...state,
                countCompare: state.countCompare-1,
                listGoods: Object.assign({}, state.listGoods, {compareList: state.listGoods.compareList.filter(elem => elem !== parseInt(action.id))} ),
                isShowLoader: false

            }
            break;

        case CLEAR_FILTERS:
            return {
                ...state,
                conditionSelected: [],
                filtersSelected: [],
                minMaxSelected: [],
                dataFilters: initialState.dataFilters,
            }
            break;
        case CLEAR_ALL_STATES:
            return {
                ...state,
                conditionSelected: [],
                filtersSelected: [],
                minMaxSelected: [],
                isChangeUrl: false,
                urlForChange: ''
            }
            break;
        default:
            return state;

    }
}
